import {BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class GeneralBroadcastService {
    private selectedModuleId = new BehaviorSubject(null);
    sharedModuleId = this.selectedModuleId.asObservable();

    private navigationMenu = new BehaviorSubject(null);
    sharedNavigationMenu = this.navigationMenu.asObservable();

    private title = new BehaviorSubject('Dashboard');
    sharedTitle = this.title.asObservable();

    private generalProperty = new BehaviorSubject({Property: null, Module: null});
    sharedSelectedProperty = this.generalProperty.asObservable();

    selectedOrganizationId: number;

    broadcastSelectedModuleId(data: any): void {
        this.selectedModuleId.next(data);
    }

    broadcastNavigation(data: any): void {
        this.navigationMenu.next(data);
    }

    broadcastTitle(data: any): void {
        this.title.next(data);
    }

    getSelectedOrganizationId(): number {
        return this.selectedOrganizationId;
    }

    setSelectedOrganizationId(pId): void {
        this.selectedOrganizationId = pId;
    }



}
